import { Box, Popover, Text, useToggle } from '@factorialco/deprecated-design-system'
import type moment from 'moment'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

interface PlusOneDayProps {
  referenceDate: moment.Moment
  date: moment.Moment
  crossesMidnight: boolean
}

const PlusOneDay = ({ referenceDate, date, crossesMidnight }: PlusOneDayProps) => {
  const [open, toggle] = useToggle(false)

  const sameDate = referenceDate.isSame(date, 'day')
  const clockInDate = sameDate ? referenceDate : date
  const clockOutDate = clockInDate.clone().add(1, 'day')
  const popoverText = crossesMidnight
    ? i18n.t('clock_in.plus_one_day.popover_clock_in_out_different_day', {
        clock_in_date: dateToString(clockInDate, 'ui_full_weekday_long_date_with_year'),
        clock_out_date: dateToString(clockOutDate, 'ui_full_weekday_long_date_with_year'),
      })
    : i18n.t('clock_in.plus_one_day.popover_clock_in_out_same_day', {
        date: dateToString(date, 'ui_full_weekday_long_date_with_year'),
      })

  return (
    <Popover.ItemList
      attachment="top center"
      targetAttachment="bottom center"
      toggle={toggle}
      open={open}
    >
      <Box cursor="pointer" paddingRight="s8">
        <Text size="300" color="grey1000">
          {i18n.t('clock_in.plus_one_day.text')}
        </Text>
      </Box>
      <Text size="300" color="grey000White" weight="semibold">
        {popoverText}
      </Text>
    </Popover.ItemList>
  )
}

export default PlusOneDay
